import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link } from '@mui/material';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Content from '../layout/content-box/Content';

function About() {
  const { aboutbanner, founderData } = Content[0];
  return (
    <>
      <Box className="aboutBanner" >
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left" alignItems="center">
            <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
              <Box className="bannerText">
                <h1>{aboutbanner[0].title}</h1>
                <p>{aboutbanner[0].para}</p>

              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <section className="founderBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="aboutHeading">
                <h2>{Content[0].aboutHeading} <br /><span>{Content[0].aboutsubHeading}</span></h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }} >
              <Box className="founderImg">
                <img src="../assets/deepak.svg" alt="Deepak Kumar Founder and CEO of mandir wiki" className="img-fluid" />
              </Box>
            </Grid>
            <Grid size={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 12 }} >
              <Box className="founderDesc">
                <h2>{founderData[0].title}</h2>
                <h3>{founderData[0].subheading} </h3>

                <p>{founderData[0].para}</p>

                <ul className='founderSocialIcon'>
                  <li><Link href="http://www.linkedin.com/in/deepakiitd" target="_blank"><LinkedInIcon /></Link></li>
                  <li><Link href="https://x.com/deepakiitdelhi" target="_blank"><XIcon /></Link></li>
                </ul>
              </Box>
            </Grid>
          </Grid>



          <Grid container spacing={2} justifyContent="left" alignItems="center" className="mt-lg-4">
            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }} >
              <Box className="founderImg">
                <img src="../assets/anand.svg" alt="Anand Mishra Co-Founder and CTO of mandir wiki" className="img-fluid" />
              </Box>
            </Grid>
            <Grid size={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 12 }} >
              <Box className="founderDesc">
                <h2>{founderData[1].title}</h2>
                <h3>{founderData[1].subheading} </h3>

                <p>{founderData[1].para}</p>

                <ul className='founderSocialIcon'>
                  <li><Link href="https://www.linkedin.com/in/anand-mishra-181591129/" target="_blank"><LinkedInIcon /></Link></li>
                  <li><Link href="#"><XIcon /></Link></li>
                </ul>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>
    </>
  );
}
export default About;